import { render, staticRenderFns } from "./table-chart-goal-registration.page.vue?vue&type=template&id=7f65807c"
import script from "./table-chart-goal-registration.page.vue?vue&type=script&lang=ts"
export * from "./table-chart-goal-registration.page.vue?vue&type=script&lang=ts"
import style0 from "./table-chart-goal-registration.page.vue?vue&type=style&index=0&id=7f65807c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports